import { SearchBaseModel } from '../commonModels';

export class CarUpdateModel extends SearchBaseModel {
  CarIds: number[];
  CarRegistrationNumbers: string[];
  MarkAll: boolean;
  CustomerId: number;
  Search: CarSearchModel;
  constructor( CarUpdate?:
    {
      CarIds?: number[], CarRegistrationNumbers?: string[], MarkAll?: boolean, CustomerId?: number, Search?: CarSearchModel
    } ) {
    super();
    this.CarIds = CarUpdate?.CarIds || new Array();
    this.CarRegistrationNumbers = CarUpdate?.CarRegistrationNumbers || new Array();
    this.MarkAll = CarUpdate?.MarkAll || false;
    this.CustomerId = CarUpdate?.CustomerId || null;
    this.Search = CarUpdate?.Search || null;
  }
}

export class CarSearchModel extends SearchBaseModel {
   public CustomerId: number;
   public GarageId: number;
   public RegistrationNumber: string;
   public IsActive: boolean;
   public Brand: string;
   public CarTypeId: number;
   public AldGarageId: number;
   public Customer: string;

   public HasNoDefinedType: boolean;
   public Vin: string;
   public IsRegistrationNumberChanged: boolean;
   public HasSpecification: boolean;
   public Lastname: string;
   public Phonenr: string;
   public HasPhone: boolean;
   public Mail: string;
   public Field1: string;
   public Field2: string;
   public Field3: string;

   public MarkAll: boolean;
   public CarIds: number[];
   public CarRegistrationNumbers: string[];
   public CanBeDeleted: boolean;

  constructor() {
    super();
    this.CustomerId = null;
    this.RegistrationNumber = null;
    this.IsActive = null;
    this.Brand = null;
    this.CarTypeId = null;
    this.AldGarageId = null;
    this.Customer = null;
    this. HasNoDefinedType = null;
    this. Vin = null;
    this. IsRegistrationNumberChanged = null;
    this. HasSpecification = null;
    this. Lastname = null;
    this. Phonenr = null;
    this. HasPhone = null;
    this. Mail = null;
    this. Field1 = null;
    this. Field2 = null;
    this. Field3 = null;
    this.MarkAll = false;
    this.CanBeDeleted = null;
  }
}
